import { useState, useEffect } from "react";
import { db } from "./firebase_config";
import { collection, getDocs, query, orderBy, where } from "firebase/firestore";

const PAYPAL_CLIENT_ID = "YFEAVLTM5EZWL";

const FORFAITS = [
  { id: "coup_pouce", nom: "Forfait Coup de Pouce", prix: 250, heures: "10h/mois", populaire: false, description: "Idéal pour les petites missions ponctuelles", lien: "https://pay.sumup.com/b2c/QVDYREHE" },
  { id: "petit_budget", nom: "Forfait Petit Budget", prix: 400, heures: "16h/mois", populaire: false, description: "Pour un accompagnement régulier léger", lien: "https://pay.sumup.com/b2c/Q1MFAZEB" },
  { id: "moyen_budget", nom: "Forfait Moyen Budget", prix: 600, heures: "26h/mois", populaire: true, description: "Notre formule la plus populaire", lien: "https://pay.sumup.com/b2c/QWT94S68" },
  { id: "budget_confort", nom: "Forfait Budget Confort", prix: 800, heures: "34h/mois", populaire: false, description: "Pour une gestion administrative complète", lien: "https://pay.sumup.com/b2c/Q5D61WTW" },
  { id: "budget_serenite", nom: "Forfait Budget Sérénité", prix: 1200, heures: "50h/mois", populaire: false, description: "Délégation totale de votre administratif", lien: "https://pay.sumup.com/b2c/Q081AYHF" },
];

const SERVICES = [
  { id: "declaration_impots", nom: "Déclaration d'impôts", prix: 25, icon: "🧾", description: "Accompagnement complet déclaration fiscale", lien: "https://pay.sumup.com/b2c/Q47OUY96" },
  { id: "contrat_travail", nom: "Contrat de travail", prix: 150, icon: "📄", description: "CDI, CDD conformes au droit français", lien: "https://pay.sumup.com/b2c/Q8RVRCQ0" },
  { id: "statuts", nom: "Rédaction de statuts", prix: 150, icon: "⚖️", description: "SAS, SARL — statuts complets", lien: "https://pay.sumup.com/b2c/QIMTMFGX" },
  { id: "cgv", nom: "Conditions Générales de Vente", prix: 150, icon: "🛒", description: "CGV conformes à la législation", lien: "https://pay.sumup.com/b2c/Q9MTOTIG" },
  { id: "previsionnel", nom: "Prévisionnel 3 ans", prix: 650, icon: "📊", description: "Business plan financier complet", lien: "https://pay.sumup.com/b2c/QUDC9IBT" },
  { id: "etude_marche", nom: "Étude de marché", prix: 450, icon: "🔍", description: "Analyse complète de votre marché", lien: "https://pay.sumup.com/b2c/QVR8SM1D" },
  { id: "conseil", nom: "Séance de conseil (1h)", prix: 30, icon: "💬", description: "Consultation administrative personnalisée", lien: "https://pay.sumup.com/b2c/QP9U2LLS" },
  { id: "contrat_prestation", nom: "Contrat de prestation", prix: 150, icon: "📋", description: "Contrat de prestation de service", lien: "https://pay.sumup.com/b2c/Q366UXBH" },
  { id: "dossier", nom: "Dossier présentation", prix: 150, icon: "📁", description: "Dossier professionnel de présentation", lien: "https://pay.sumup.com/b2c/QZ4VN9I9" },
  { id: "pack_contrat", nom: "Pack fin de contrat", prix: 175, icon: "📦", description: "Pack complet documents fin de contrat", lien: "https://pay.sumup.com/b2c/QLUIY3ZU" },
  { id: "formulaires", nom: "Formulaires administratifs", prix: 55, icon: "📝", description: "Création de formulaires personnalisés", lien: "https://pay.sumup.com/b2c/QFAW1ZLF" },
  { id: "publipostage", nom: "Trame de publipostage", prix: 35, icon: "📨", description: "Trame de publipostage avec liens", lien: "https://pay.sumup.com/b2c/QB1CF7Y9" },
  { id: "annonce", nom: "Rédaction annonce journal légal", prix: 35, icon: "📰", description: "Rédaction de votre annonce légale", lien: "https://pay.sumup.com/b2c/QYD3HJFS" },
  { id: "espace_ligne", nom: "Création espace en ligne", prix: 30, icon: "💻", description: "Création espace Urssaf, impôt, net entreprise", lien: "https://pay.sumup.com/b2c/QLPS9R8C" },
  { id: "concurrence", nom: "Étude de la concurrence", prix: 250, icon: "🔎", description: "Analyse complète de votre concurrence", lien: "https://pay.sumup.com/b2c/QPS2OEO5" },
  { id: "kbis_greffe", nom: "K-Bis au Greffe", prix: 10, icon: "🏛️", description: "Fourniture de K-BIS au Greffe", lien: "https://pay.sumup.com/b2c/QAKQLR2Y" },
  { id: "kbis_chambre", nom: "K-Bis Chambre des Métiers", prix: 15, icon: "🏢", description: "Fourniture de K-BIS Chambre des Métiers", lien: "https://pay.sumup.com/b2c/Q7Q01AOA" },
  { id: "veille", nom: "Veille téléphonique", prix: 100, icon: "📞", description: "Veille téléphonique mensuelle", lien: "https://pay.sumup.com/b2c/QCR309DB" },
  { id: "creation_entreprise", nom: "Création d'entreprise", prix: null, prixLabel: "Sur devis", icon: "🏗️", description: "Statuts, immatriculation, Kbis", lien: null },
];

// ── Panier Modal ────────────────────────────────────────────────
function PanierModal({ panier, onClose, onRemove, onUpdateQty, C1, C2 }) {
  const total = panier.reduce((sum, item) => sum + (item.prix || 0) * item.qty, 0);
  const hasDevis = panier.some(item => !item.prix);
  const [payMethod, setPayMethod] = useState(null);

  const payerSumUp = () => {
    panier.forEach((item, i) => {
      if (item.lien) {
        for (let q = 0; q < item.qty; q++) {
          setTimeout(() => window.open(item.lien, "_blank"), (i + q) * 500);
        }
      }
    });
    onClose();
  };

  const payerPayPal = () => {
    const description = panier.map(i => `${i.nom} x${i.qty}`).join(", ");
    const url = `https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=${PAYPAL_CLIENT_ID}&item_name=${encodeURIComponent(description)}&amount=${total}&currency_code=EUR`;
    window.open(url, "_blank");
    onClose();
  };

  const devis = () => {
    const msg = `Bonjour, je souhaite un devis pour : ${panier.map(i => i.nom).join(", ")}`;
    window.location.href = `mailto:cdassist97190@gmail.com?subject=Demande de devis CD'ASSIST&body=${encodeURIComponent(msg)}`;
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(26,10,46,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "36px 32px", maxWidth: 480, width: "100%", boxShadow: "0 24px 80px rgba(107,45,139,0.2)", position: "relative", maxHeight: "90vh", overflowY: "auto" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#9B7BB8" }}>✕</button>

        <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, color: "#1A0A2E", marginBottom: 24 }}>🛒 Mon panier</h2>

        {panier.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px 0", color: "#9B7BB8" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🛒</div>
            <p>Votre panier est vide</p>
          </div>
        ) : (
          <>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
              {panier.map((item, i) => (
                <div key={i} style={{ padding: "12px 16px", background: "#faf7ff", borderRadius: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#1A0A2E" }}>{item.nom}</div>
                    <button onClick={() => onRemove(i)} style={{ background: "rgba(239,68,68,0.1)", color: "#DC2626", border: "none", width: 24, height: 24, borderRadius: "50%", cursor: "pointer", fontSize: 14 }}>×</button>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* Quantité */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <button onClick={() => onUpdateQty(i, item.qty - 1)} style={{ width: 28, height: 28, borderRadius: "50%", border: `1.5px solid ${C1}`, background: "#fff", color: C1, fontWeight: 700, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                      <span style={{ fontSize: 15, fontWeight: 700, color: "#1A0A2E", minWidth: 24, textAlign: "center" }}>{item.qty}</span>
                      <button onClick={() => onUpdateQty(i, item.qty + 1)} style={{ width: 28, height: 28, borderRadius: "50%", border: `1.5px solid ${C1}`, background: C1, color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                      <span style={{ fontSize: 12, color: "#9B7BB8" }}>× {item.prix ? `${item.prix}€` : "devis"}</span>
                    </div>
                    <span style={{ fontWeight: 700, color: C1, fontSize: 15 }}>
                      {item.prix ? `${item.prix * item.qty}€` : "Sur devis"}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ borderTop: "2px solid #f3e8ff", paddingTop: 16, marginBottom: 24 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 16, fontWeight: 700, color: "#1A0A2E" }}>Total</span>
                <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 32, fontWeight: 700, color: C1 }}>
                  {total > 0 ? `${total}€` : "Sur devis"}
                </span>
              </div>
              {hasDevis && <p style={{ fontSize: 12, color: "#9B7BB8" }}>* Certains services sont sur devis</p>}
            </div>

            {total > 0 ? (
              <>
                <p style={{ fontSize: 13, color: "#9B7BB8", marginBottom: 14, textAlign: "center" }}>Choisissez votre moyen de paiement :</p>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <button onClick={payerSumUp} style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 20px", border: `2px solid ${C1}`, borderRadius: 14, background: "rgba(196,0,106,0.04)", cursor: "pointer", width: "100%" }}>
                    <div style={{ width: 48, height: 32, background: `linear-gradient(135deg,${C1},${C2})`, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ color: "#fff", fontSize: 11, fontWeight: 700 }}>SumUp</span>
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1A0A2E" }}>Payer par carte bancaire</div>
                      <div style={{ fontSize: 12, color: "#9B7BB8" }}>{panier.reduce((s,i) => s + i.qty, 0) > 1 ? `${panier.reduce((s,i) => s + i.qty, 0)} paiements séparés` : "Visa, Mastercard — Paiement sécurisé"}</div>
                    </div>
                    <span style={{ marginLeft: "auto" }}>→</span>
                  </button>

                  <button onClick={payerPayPal} style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 20px", border: "2px solid #0070BA", borderRadius: 14, background: "rgba(0,112,186,0.04)", cursor: "pointer", width: "100%" }}>
                    <div style={{ width: 48, height: 32, background: "#003087", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ color: "#009CDE", fontSize: 14, fontWeight: 900 }}>P</span>
                      <span style={{ color: "#fff", fontSize: 14, fontWeight: 900 }}>P</span>
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1A0A2E" }}>Payer avec PayPal</div>
                      <div style={{ fontSize: 12, color: "#9B7BB8" }}>Compte PayPal ou carte bancaire</div>
                    </div>
                    <span style={{ marginLeft: "auto" }}>→</span>
                  </button>
                </div>
              </>
            ) : (
              <button onClick={devis} style={{ width: "100%", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", border: "none", padding: "15px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
                📧 Demander un devis gratuit
              </button>
            )}

            <div style={{ marginTop: 14, padding: 12, background: "#faf7ff", borderRadius: 10, display: "flex", alignItems: "center", gap: 8 }}>
              <span>🔒</span>
              <p style={{ fontSize: 11, color: "#9B7BB8" }}>Paiement 100% sécurisé. TVA non applicable, art. 293B du CGI.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function Boutique({ navigate, C1 = "#C4006A", C2 = "#6B2D8B" }) {
  const [activeTab, setActiveTab] = useState("forfaits");
  const [panier, setPanier] = useState([]);
  const [showPanier, setShowPanier] = useState(false);
  const [articles, setArticles] = useState([]);
  const [loadingArticles, setLoadingArticles] = useState(true);

  useEffect(() => {
    const loadArticles = async () => {
      try {
        const snap = await getDocs(query(collection(db, "articles_boutique"), where("actif", "==", true), orderBy("createdAt", "desc")));
        setArticles(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) { console.log(e); }
      setLoadingArticles(false);
    };
    loadArticles();
  }, []);

  const ajouterAuPanier = (item) => {
    // Si l'article est déjà dans le panier, augmente la quantité
    const existingIndex = panier.findIndex(p => p.id === item.id);
    if (existingIndex >= 0) {
      const newPanier = [...panier];
      newPanier[existingIndex].qty += 1;
      setPanier(newPanier);
    } else {
      setPanier(p => [...p, { ...item, qty: 1 }]);
    }
  };

  const retirerDuPanier = (index) => {
    setPanier(p => p.filter((_, i) => i !== index));
  };

  const updateQty = (index, newQty) => {
    if (newQty <= 0) {
      retirerDuPanier(index);
    } else {
      const newPanier = [...panier];
      newPanier[index] = { ...newPanier[index], qty: newQty };
      setPanier(newPanier);
    }
  };

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600;700&display=swap');
    .boutique-card{background:#fff;border-radius:16px;padding:28px 24px;box-shadow:0 4px 20px rgba(107,45,139,0.07);border:1.5px solid rgba(196,0,106,0.07);transition:all .3s;}
    .boutique-card:hover{transform:translateY(-5px);box-shadow:0 16px 40px rgba(107,45,139,0.14);border-color:${C1};}
    .tab-btn{padding:10px 24px;border-radius:50px;font-family:'DM Sans',sans-serif;font-weight:600;font-size:14px;cursor:pointer;transition:all .2s;border:2px solid;}
    .tab-active{background:linear-gradient(135deg,${C1},${C2});color:#fff;border-color:transparent;}
    .tab-inactive{background:transparent;color:${C2};border-color:${C2};}
    .btn-panier{background:linear-gradient(135deg,${C1},${C2});color:#fff;border:none;padding:9px 18px;border-radius:50px;font-family:'DM Sans',sans-serif;font-weight:700;font-size:12px;cursor:pointer;transition:all .3s;}
    .btn-panier:hover{transform:translateY(-2px);box-shadow:0 6px 20px rgba(196,0,106,0.4);}
  `;

  return (
    <div style={{ padding: "120px 32px 80px", minHeight: "100vh", background: "linear-gradient(135deg,#faf7ff,#fff0f7)" }}>
      <style>{css}</style>

      {showPanier && <PanierModal panier={panier} onClose={() => setShowPanier(false)} onRemove={retirerDuPanier} onUpdateQty={updateQty} C1={C1} C2={C2} />}

      <div style={{ maxWidth: 1100, margin: "0 auto" }}>

        {/* Header avec panier */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 40, flexWrap: "wrap", gap: 20 }}>
          <div>
            <span style={{ display: "inline-block", background: `linear-gradient(135deg,rgba(196,0,106,0.1),rgba(107,45,139,0.1))`, color: C1, padding: "5px 16px", borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", border: `1px solid rgba(196,0,106,0.2)`, marginBottom: 12 }}>Boutique en ligne</span>
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: "clamp(32px,5vw,48px)", fontWeight: 700, color: "#1A0A2E", marginBottom: 8 }}>Nos services</h1>
            <p style={{ fontSize: 15, color: "#6B7280", maxWidth: 480 }}>Ajoutez des services à votre panier et payez en toute sécurité.</p>
          </div>

          {/* Bouton panier */}
          <button onClick={() => setShowPanier(true)} style={{ position: "relative", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", border: "none", padding: "14px 24px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 15, cursor: "pointer", display: "flex", alignItems: "center", gap: 10, boxShadow: "0 8px 28px rgba(196,0,106,0.35)" }}>
            🛒 Mon panier
            {panier.length > 0 && (
              <span style={{ background: "#fff", color: C1, borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 900 }}>{panier.length}</span>
            )}
          </button>
        </div>

        {/* Nouveautés */}
        {articles.length > 0 && (
          <div style={{ marginBottom: 36, background: "linear-gradient(135deg,rgba(196,0,106,0.05),rgba(107,45,139,0.05))", borderRadius: 20, padding: "24px 28px", border: "1.5px solid rgba(196,0,106,0.15)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <span style={{ fontSize: 24 }}>✨</span>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, color: "#1A0A2E" }}>Nouveautés — Outils & Modèles</h2>
              <span style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>NEW</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 16 }}>
              {articles.slice(0, 3).map(a => (
                <div key={a.id} style={{ background: "#fff", borderRadius: 14, padding: "18px 20px", boxShadow: "0 2px 12px rgba(107,45,139,0.08)", display: "flex", flexDirection: "column", gap: 8 }}>
                  <span style={{ fontSize: 10, fontWeight: 700, background: "rgba(196,0,106,0.1)", color: "#C4006A", padding: "2px 10px", borderRadius: 20, alignSelf: "flex-start" }}>{a.categorie}</span>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 700, color: "#1A0A2E" }}>{a.nom}</div>
                  <div style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.5 }}>{a.description?.slice(0, 80)}{a.description?.length > 80 ? "..." : ""}</div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
                    <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 700, color: "#C4006A" }}>{a.prix}€</span>
                    {a.lienPaiement ? (
                      <a href={a.lienPaiement} target="_blank" rel="noopener noreferrer" style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", textDecoration: "none", padding: "7px 16px", borderRadius: 50, fontSize: 12, fontWeight: 700 }}>
                        💳 Acheter
                      </a>
                    ) : (
                      <button onClick={() => setActiveTab("documents")} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "7px 16px", borderRadius: 50, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                        Voir →
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {articles.length > 3 && (
              <button onClick={() => setActiveTab("documents")} style={{ marginTop: 16, background: "transparent", border: "2px solid rgba(196,0,106,0.3)", color: "#C4006A", padding: "9px 22px", borderRadius: 50, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
                Voir tous les outils & modèles ({articles.length}) →
              </button>
            )}
          </div>
        )}

        {/* Tabs */}
        <div style={{ display: "flex", gap: 12, marginBottom: 36, flexWrap: "wrap" }}>
          <button className={`tab-btn ${activeTab === "forfaits" ? "tab-active" : "tab-inactive"}`} onClick={() => setActiveTab("forfaits")}>📦 Forfaits mensuels</button>
          <button className={`tab-btn ${activeTab === "services" ? "tab-active" : "tab-inactive"}`} onClick={() => setActiveTab("services")}>🛠️ Services à la carte</button>
          <button className={`tab-btn ${activeTab === "documents" ? "tab-active" : "tab-inactive"}`} onClick={() => setActiveTab("documents")}>🎁 Outils & Modèles {articles.length > 0 && `(${articles.length})`}</button>
        </div>

        {/* DOCUMENTS */}
        {activeTab === "documents" && (
          <div>
            {loadingArticles ? (
              <div style={{ textAlign: "center", padding: "48px", color: "#9B7BB8" }}>Chargement...</div>
            ) : articles.length === 0 ? (
              <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 16, boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>📄</div>
                <p style={{ color: "#9B7BB8" }}>Aucun document disponible pour le moment.</p>
                <p style={{ fontSize: 13, color: "#9B7BB8", marginTop: 8 }}>Revenez bientôt !</p>
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 20 }}>
                {articles.map(a => (
                  <div key={a.id} className="boutique-card" style={{ border: "1.5px solid rgba(196,0,106,0.07)" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, background: "rgba(196,0,106,0.1)", color: C1, padding: "3px 10px", borderRadius: 20, display: "inline-block", marginBottom: 12 }}>{a.categorie}</div>
                    <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 8 }}>{a.nom}</h3>
                    <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6, flex: 1, marginBottom: 16 }}>{a.description}</p>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, fontWeight: 700, color: C1 }}>{a.prix}€</span>
                      <span style={{ fontSize: 11, background: "rgba(16,185,129,0.1)", color: "#059669", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>📄 PDF</span>
                    </div>
                    {a.lienPaiement ? (
                      <a href={a.lienPaiement} target="_blank" rel="noopener noreferrer"
                        style={{ display: "block", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", textDecoration: "none", padding: "12px", borderRadius: 50, textAlign: "center", fontSize: 14, fontWeight: 700 }}>
                        💳 Acheter & Télécharger
                      </a>
                    ) : (
                      <button onClick={() => navigate("contact")}
                        style={{ width: "100%", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", border: "none", padding: "12px", borderRadius: 50, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                        📩 Contacter pour acheter
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* FORFAITS */}
        {activeTab === "forfaits" && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))", gap: 20, marginBottom: 32 }}>
              {FORFAITS.map(f => (
                <div key={f.id} className="boutique-card" style={{ position: "relative", border: f.populaire ? `2px solid ${C1}` : "1.5px solid rgba(196,0,106,0.07)", textAlign: "center" }}>
                  {f.populaire && <div style={{ position: "absolute", top: -13, left: "50%", transform: "translateX(-50%)", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", padding: "3px 14px", borderRadius: 20, fontSize: 10, fontWeight: 700, whiteSpace: "nowrap" }}>⭐ POPULAIRE</div>}
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 19, fontWeight: 700, color: "#1A0A2E", marginBottom: 8 }}>{f.nom}</div>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 44, fontWeight: 700, color: f.populaire ? C1 : C2 }}>{f.prix}€</div>
                  <div style={{ fontSize: 12, color: "#9B7BB8", marginBottom: 8 }}>/mois</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: C1, background: "rgba(196,0,106,0.08)", padding: "5px 12px", borderRadius: 20, marginBottom: 12 }}>{f.heures}</div>
                  <p style={{ fontSize: 12, color: "#6B7280", marginBottom: 16, lineHeight: 1.5 }}>{f.description}</p>
                  <div style={{ display: "flex", gap: 8, flexDirection: "column" }}>
                    <button className="btn-panier" onClick={() => { ajouterAuPanier(f); setShowPanier(true); }}>🛒 Ajouter au panier</button>
                    <button onClick={() => window.open(f.lien, "_blank")} style={{ background: "transparent", border: `1.5px solid ${C1}`, color: C1, padding: "8px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>💳 Payer maintenant</button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ background: "#fff", borderRadius: 16, padding: "20px 28px", boxShadow: "0 2px 16px rgba(107,45,139,0.06)", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
              <span style={{ fontSize: 24 }}>💡</span>
              <p style={{ fontSize: 14, color: "#6B7280", flex: 1 }}>Forfaits renouvelés chaque mois. Résiliables à tout moment. <strong style={{ color: "#1A0A2E" }}>TVA non applicable, art. 293B du CGI.</strong></p>
              <button onClick={() => navigate("contact")} style={{ background: "transparent", border: `2px solid ${C2}`, color: C2, padding: "10px 22px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}>Besoin d'aide ? →</button>
            </div>
          </>
        )}

        {/* SERVICES */}
        {activeTab === "services" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 20 }}>
            {SERVICES.map(s => (
              <div key={s.id} className="boutique-card">
                <div style={{ fontSize: 32, marginBottom: 14 }}>{s.icon}</div>
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 8 }}>{s.nom}</h3>
                <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6, marginBottom: 16 }}>{s.description}</p>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                  <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, fontWeight: 700, color: C1 }}>
                    {s.prix ? `${s.prix}€` : s.prixLabel}
                  </span>
                </div>
                {s.lien ? (
                  <div style={{ display: "flex", gap: 8, flexDirection: "column" }}>
                    <button className="btn-panier" onClick={() => { ajouterAuPanier(s); setShowPanier(true); }}>🛒 Ajouter au panier</button>
                    <button onClick={() => window.open(s.lien, "_blank")} style={{ background: "transparent", border: `1.5px solid ${C1}`, color: C1, padding: "8px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>💳 Payer maintenant</button>
                  </div>
                ) : (
                  <button onClick={() => { const msg = `Bonjour, je souhaite un devis pour : ${s.nom}`; window.location.href = `mailto:cdassist97190@gmail.com?subject=Devis ${s.nom}&body=${encodeURIComponent(msg)}`; }} style={{ width: "100%", background: `linear-gradient(135deg,${C1},${C2})`, color: "#fff", border: "none", padding: "11px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                    📧 Demander un devis
                  </button>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Sécurité */}
        <div style={{ marginTop: 48, display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))", gap: 20 }}>
          {[
            { icon: "🔒", title: "Paiement sécurisé", desc: "Cryptage SSL 256 bits" },
            { icon: "✅", title: "Satisfait ou remboursé", desc: "Sous 14 jours si non commencé" },
            { icon: "📧", title: "Confirmation immédiate", desc: "Email dès le paiement" },
          ].map(g => (
            <div key={g.title} style={{ background: "#fff", borderRadius: 14, padding: "20px 18px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.05)" }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>{g.icon}</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#1A0A2E", marginBottom: 6 }}>{g.title}</div>
              <div style={{ fontSize: 12, color: "#9B7BB8" }}>{g.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
